import { createFileRoute } from '@tanstack/react-router'
import { NavStack, NavStackStage, NavStackScreen } from '@/components/custom/route-transition'
import { ScrollableArea } from './-components/shared/layout'

// THE STICKY REPRO: a `position: sticky` bar under some content of the level's own, over enough rows to scroll its
// pane — the report's profile selector under its header. The level's pane is the scroller on a phone, so the content
// above scrolls away and the bar pins at the pane's top. Asserted by `sticky-in-stack.e2e.test.ts`.
export const Route = createFileRoute('/_app/admin/transitions/sticky')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <NavStack levels={[true]} onPop={() => {}}>
      <NavStackStage className="flex h-full min-h-0 w-full" style={{ containerType: 'inline-size' }}>
        <NavStackScreen index={0} title="Sticky repro">
          <ScrollableArea>
            <div className="text-muted-foreground flex flex-col gap-2 p-4 text-sm">
              <p className="text-foreground font-medium">Above the bar</p>
              <p>The level's own content, which scrolls away while the bar below pins at the pane's top.</p>
            </div>
            <div
              data-sticky-probe=""
              className="bg-background sticky top-0 z-20 border-b px-4 py-3 text-sm font-medium"
            >
              Sticky bar — must stay put while the rows below scroll
            </div>
            <div className="flex flex-col gap-3 p-4">
              {Array.from({ length: 60 }, (_, i) => (
                <div key={i} className="rounded-md border p-3 text-sm">
                  Row {i + 1}
                </div>
              ))}
            </div>
          </ScrollableArea>
        </NavStackScreen>
      </NavStackStage>
    </NavStack>
  )
}
